import {Stack} from 'quickstart/components/layout/Stack'
import {MetaSummary} from 'quickstart/components/tizra/MetaSummary'
import {logger, meta} from 'tizra'
import type {BrowseGalleryProps} from '..'

const log = logger('BrowseGallery/list')

export const ListGallery = ({search: {lastResults}}: BrowseGalleryProps) => (
  <Stack spacing="md" divided>
    {lastResults?.map(r => (
      <MetaSummary key={meta.key(r)} metaObj={r} />
    ))}
  </Stack>
)
